import { TAGS } from "../constants";
import {
  PaymentInformation,
  SetDefaultPaymentMethodBody,
  SetDefaultPaymentMethodReturn,
} from "../types";
import { api } from "./api";

export const paymentInformationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPatientPaymentsInformation: builder.query<PaymentInformation[], number>({
      query: (patientId) => ({
        method: "GET",
        url: `/api/payment-information/patient/${patientId}`,
      }),
      providesTags: (_res, _error, args) => [
        {
          type: TAGS.PAYMENTS_INFORMATION,
          id: args,
        },
      ],
    }),
    setDefaultPaymentMethod: builder.mutation<
      SetDefaultPaymentMethodReturn,
      SetDefaultPaymentMethodBody
    >({
      query: (body) => ({
        method: "POST",
        url: `/api/payments/default-method`,
        body,
      }),
      invalidatesTags: [TAGS.PAYMENT_METHODS, TAGS.PAYMENTS_INFORMATION],
    }),
  }),
});

export const {
  useGetPatientPaymentsInformationQuery,
  useSetDefaultPaymentMethodMutation,
} = paymentInformationApi;
